import client from '@/shared/apis/client'
import { DispenseAuditResponse } from '../types/dispenseAudit'

export const getDispenseAudit = async (
  yakurekiId: string
): Promise<DispenseAuditResponse | null> => {
  const response = await client.get(
    `/api/request-events/${yakurekiId}/dispense-audit/`
  )
  if (response.status === 204) return null
  return response.data
}

export const postDispenseAudit = async (
  yakurekiId: string,
  image: File
): Promise<DispenseAuditResponse> => {
  const formData = new FormData()
  formData.append('image', image)

  const response = await client.post<DispenseAuditResponse>(
    `/api/request-events/${yakurekiId}/dispense-audit/`,
    formData
  )
  return response.data
}
